import { render, staticRenderFns } from "./Grupos.vue?vue&type=template&id=18411bf6&"
import script from "./Grupos.vue?vue&type=script&lang=js&"
export * from "./Grupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports